import React from "react";
import SourcingRequestForm from "../SourcingRequestForm";
import formikSchema from "./formikSchema";
import { useLoginContext } from "common";

const AddSourcingRequest = () => {
  const { currentUser } = useLoginContext();
  return <SourcingRequestForm formikSchema={formikSchema(currentUser)} />;
};

export default AddSourcingRequest;
